<template>
  <div style="width:100%" class="elevation-2 pt-3 pl-3 pr-3">
    <Loading :value="loading"></Loading>
    <h4 mt-2>LISTES DES TRAVAUX {{ periode }}</h4>
    <v-divider></v-divider>
    <v-layout wrap mt-3>
      <v-flex xs12>
        <v-layout row class="mb-4 mt-1">
          <v-flex md4 class="mr-1">
            <el-select
              clearable
              filterable
              @change="filtrerTravaux()"
              v-model="travauxS"
              placeholder="Selectionner un travaux"
              style="width:100%"
            >
              <el-option
                v-for="item in litesDesTrx"
                :key="item.idTrx"
                :label="item.libelle"
                :value="item.idTrx"
              >
              </el-option>
            </el-select>
          </v-flex>

          <v-flex md4 class="mr-1" v-if="travauxS != ''">
            <el-select
              clearable
              filterable
              @change="filtrerChantier()"
              v-model="chantierS"
              placeholder="Selectionner un chantier"
              style="width:100%"
            >
              <el-option
                v-for="item in listeChantier"
                :key="item.idChant"
                :label="item.libChantier"
                :value="item.idChant"
              >
              </el-option>
            </el-select>
          </v-flex>

          <v-flex xs2 class="text-xs-right">
            <v-tooltip top>
              <v-btn
                slot="activator"
                color="orange"
                @click.stop="imprimeAllTravaux()"
                dark
              >
                Imprimer <v-icon>print</v-icon>
              </v-btn>
              Imprimer la liste des travaux
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs12>
           <el-select   filterable  @change="filtrerRptAValid()" v-model="rptAValid" placeholder="Selectionner" style="width:100%">
                  <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                  </el-option>
              </el-select>
      </v-flex> -->

      <v-flex xs12>
        <data-tables
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="litesDesTrx"
          style="width:100%;"
        >
          <el-table-column
            prop="libelle"
            label="TRAVAUX"
            align="center"
            width="230"
            fixed
          >
          </el-table-column>
          <el-table-column
            prop="libProjChant"
            label="PROJET/CHANTIER"
            align="center"
            width="230"
            fixed
          >
          </el-table-column>
          <el-table-column label="DATE" align="center">
            <el-table-column prop="dateD" label="DEBUT"></el-table-column>
            <el-table-column prop="dateF" label="FIN"></el-table-column>
            <el-table-column prop="duree" label="DUREE (Jours) ">
            </el-table-column>
          </el-table-column>
          <!-- <el-table-column prop="mntEstime" label="COÛT ESTIME" align="center">
                        </el-table-column>
                        <el-table-column prop="mntTrx" label="COÛT REALISES" align="center">
                        </el-table-column> -->
          <el-table-column label="EVOLUTION" align="center">
            <template slot-scope="scope">
              <v-progress-circular
                :size="80"
                :width="15"
                :rotate="360"
                :value="scope.row.evolution"
                color="orange"
              >
                {{ scope.row.evolutionNbr }} %
              </v-progress-circular>
            </template>
          </el-table-column>
          <el-table-column
            prop="libEtat"
            label="STATUS"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="qteTotEfect"
            label="QTE( EFFECT/TOTAL)"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="idRapport"
            label="RAPPORT JOURNALIER"
            align="center"
          ></el-table-column>
          <!-- <el-table-column prop="nbRptAVal" label="NB RAPPORT A VALIDER" align="center"></el-table-column> -->
          <el-table-column
            label="ACTION"
            align="center"
            width="250"
            fixed="right"
          >
            <template slot-scope="scope">
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  @click="showModalTache(scope.row)"
                  fab
                  dark
                  small
                  color="blue"
                >
                  <v-icon dark>terrain</v-icon>
                </v-btn>
                <span>taches</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn
                  v-if="scope.row.etat == 1 && !commis && scope.row.evolutionNbr != 100"
                  @click.native="
                    detailTravaux = scope.row;
                    dialogConfirmRefus = true;
                  "
                  slot="activator"
                  icons
                  color="red"
                  fab
                  dark
                  small
                >
                  <v-icon>stop</v-icon>
                </v-btn>
                <span>Suspendre les travaux</span>
              </v-tooltip>
              
              <v-tooltip bottom>
                <v-btn
                  @click.native="loadRapportTrx(scope.row)"
                  v-if="scope.row.nbJour == true"
                  slot="activator"
                  icons
                  color="purple"
                  fab
                  dark
                  small
                >
                  <v-icon>assignment</v-icon> </v-btn
                >Liste des rapports
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn
                  v-if="
                    scope.row.isRapport == false &&
                      scope.row.evolutionNbr != 100 &&
                      scope.row.etat == 1
                  "
                  @click.native="
                    detailTravaux = scope.row;
                    showRapport = true;
                  "
                  slot="activator"
                  color="orange"
                  fab
                  dark
                  small
                >
                  <v-icon>note_add</v-icon> </v-btn
                >Effectuer rapport journalier
              </v-tooltip>
            </template>
          </el-table-column>
        </data-tables>
      </v-flex>
    </v-layout>

    <!-- RAPPORT JOURNALIERS-->
    <RapportJournalier
      :detailTrx="detailTravaux"
      :show="showRapport"
      @close="showRapport = false"
      @reloadListeTrx="$emit('reloadListeTravaux')"
    >
    </RapportJournalier>
    <!-- RAPPORT JOURNALIERS -->

    <!-- MODAL STOP TRAVAUX -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogConfirmRefus" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"
            >Arrêter les travaux: {{ detailTravaux.libelle }}</v-card-title
          >
          <v-card-text>
            <el-alert
              title="Arrêt Travaux"
              description="Toutes les tâches issues des travaux seront également arretées, pour relancer les travaux vous devez demarrer au moins une tâche"
              type="warning"
              center
              :closable="false"
              show-icon
            >
            </el-alert>
            <el-form
              id="formRefus"
              ref="formRefus"
              label-position="top"
              :inline="true"
              :model="formRefus"
              class="demo-form-inline"
            >
              <v-flex xs12>
                <el-form-item
                  style="width:100%"
                  label="Voulez vous Arreter les travaux?"
                >
                  <el-input
                    style="width:100%"
                    type="textarea"
                    :rows="6"
                    placeholder="Pourquoi voulez-vous Arreter cette tâche ?"
                    v-model="formRefus.rapport"
                  ></el-input>
                </el-form-item>
              </v-flex>
            </el-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat
              @click.native="dialogConfirmRefus = false"
              >Annuler</v-btn
            >
            <v-btn
              color="green darken-1"
              flat
              @click="submitFormStop('formRefus')"
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- MODAL STOP TRAVAUX-->

    <v-dialog
      v-model="dialogListeRapport"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <Loading :value="loading"></Loading>
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >LISTE DES RAPPORTS DES TRAVAUX :
            {{ detailTravaux.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogListeRapport = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>

          <!-- LISTE DES RAPPORT TRAVAUX-->
          <ListeRapportTrx
            :libTrx="detailTravaux.libelle"
            :type="type"
            :commis="commis"
            :typeInterface="true"
            :IddetailTravaux="detailTravaux.idTrx"
            :show="dialogListeRapport"
            :listeRapportTrx="listeRapports"
            @close="dialogListeRapport = false"
          >
          </ListeRapportTrx>
          <!-- LISTE DES RAPPORT TRAVAUX -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DASHBOARD CHANTIER-->
    <IndexTache
      :detailTrx="detailTravaux"
      :show="showDetailTache"
      :commis="commis"
      @close="
        $emit('reloadListeTravaux');
        showDetailTache = false;
      "
      @reloadTrx="$emit('reloadListeTravaux')"
    >
    </IndexTache>
    <!-- DASHBOARD CHANTIER -->
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import IndexTache from "@/components/boardChantier/index_tache_chantier";
import RapportJournalier from "@/components/boardChantier/RapportJournalier";
import ListeRapportTrx from "@/components/rapport/ListeRapportTrx";

export default {
  components: { Loading, IndexTache, RapportJournalier, ListeRapportTrx },
  name: "ListeTravaux",
  props: {
    show: {
      type: Boolean
    },
    commis: {
        type: Boolean
    },
    type: {
      type: Number, //0=>chef travaux 1=>chantier//2=>projet
      default: 0
    },
    listeTrx: {
      type: Array
    },
    listeTrxId: {
      type: Array
    },
    periode: {
      type: String,
      default: null
    },
    idChantier: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      listeRapports: [],
      showDetailTache: false,
      formRefus: {},
      travauxS: "",
      multipleSelection: [],

      //FILTRE
      listeProjet: [],
      projetS: "",
      chantierS: "",
      oldListTravaux: [],
      litesDesTrx: [],
      listeTravaux: [],
      listeChantier: [],
      rptAValid: 0,
      etatRpt: [
        {
          libelle: "Tous les travaux",
          value: "0"
        },
        {
          libelle: "Trx avec rapport à valider",
          value: "1"
        }
      ]
    };
  },
  watch: {
    show: function(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeTrx: function(newValue, oldvalue) {
      this.litesDesTrx = this.listeTrx;
      this.idChant = this.idchantier;
    }
  },

  methods: {
    filtrerTravaux() {
      let TravauxValeur = this.travauxS;
      if (
        TravauxValeur == null ||
        TravauxValeur == "undefined" ||
        TravauxValeur == ""
      ) {
        let valeur = this.litesDesTrx;
        this.litesDesTrx = valeur;
        return;
      }

      var tab = this.litesDesTrx;
      this.litesDesTrx = this.litesDesTrx.filter(function(item) {
        return item.idTrx == TravauxValeur;
      });

      var tableau = tab.filter(function(item) {
        return item.idTrx == TravauxValeur;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTache === tableau[j].idTache) {
            tableau.splice(j--, 1);
          }
        }
      }
      this.listeChantier = tableau;
    },
    filtrerChantier() {
      let idChantier = this.chantierS;
      if (idChantier == null || idChantier == "undefined" || idChantier == "") {
        this.filtrerTravaux();
        return;
      }
      let tab = this.litesDesTrx;
      this.idChantier = tab.filter(function(item) {
        return item.idChant == idChantier;
      });
    },
    submitFormStop(formName) {
      if (
        this.formRefus.rapport != "undefined" &&
        this.formRefus.rapport != null
      ) {
        this.loading = true;
        let url = this.domaine + "travaux/stop/" + this.detailTravaux.idTrx;
        let data = new FormData();

        data.append("idUser", this.user.id);
        data.append("rapport", this.formRefus.rapport);

        this.$http.post(url, data).then(
          response => {
            //reinitialiser le formulaire
            this.loading = false;
            this.dialogConfirmRefus = false;
            this.formRefus.rapport = "";
            let mess = response.body.message;
            //this.loadTravaux(this.detailChantier);
            this.$emit("reloadListeTravaux");

            this.$notify({
              title: "LES TRAVAUX ONT ETE ARRETE",
              message: mess,
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.formRefus.rapport = "";
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } //rapport non saisie
      else {
        this.$message.error("Veuillez remplir correctement les champs svp...");
      }
    },
    closeDialog() {
      this.$emit("close");
    },
    showModalTache(trx) {
      this.detailTravaux = trx;
      this.showDetailTache = true;
    },
    loadRapportTrx(trx) {
      this.detailTravaux = trx;
      this.loading = true;
      let url      
      if(this.commis){
        url = this.domaine + "journal/travaux/" + this.detailTravaux.idTrx+"?idUser="+this.user.id;
      }else {
        url = this.domaine + "journal/travaux/" + this.detailTravaux.idTrx;
      }
      this.$http.get(url).then(
        response => {
          this.listeRapports = response.body.journaux;
          this.dialogListeRapport = true;
          this.type = 1;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des Journaux");
        }
      );
    },
    //FILTRE
    loadProjet() {
      this.listeChantier.splice(0);
      this.chantierS = null;
      let url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProjet = response.body.projet;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },
    loadChantier() {
      if (
        this.projetS == null ||
        this.projetS == "undefined" ||
        this.projetS == ""
      ) {
        this.litesDesTrx = this.listeTrx;
        return;
      }
      this.loading = true;
      let url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeChantier = response.body.chantier;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    clearSelect() {
      //this.listeTrx = this.oldListTravaux;
      this.projetS = "";
      this.chantierS = "";
      this.listeChantier.splice(0);
    },

    imprimeAllTravaux() {
      let url =
        this.domaine +
        "travaux/impression/listeTravaux/chantier/" +
        this.idChantier +
        "/" +
        this.user.id;
      window.open(url);
    }
  },
  mounted() {
    this.loadChantier();
    this.clearSelect();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/boardTravaux/ListeTravaux.vue